import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import StackGuide from "@/pages/StackGuide";

export const Route = createFileRoute("/stack/guide")({
  head: () => seoHead("/stack/guide"),
  component: StackGuide,
});
